import { StyledTd } from "./baseTd.jsx";

export const VoidCell = (props: { className: string }) => {
  const cell = <StyledTd class={props.className}></StyledTd>;
  return cell;
};
